import { useState } from "react";
import type { CSSProperties } from "react";
import { gradientBackground } from "../colorUtils";

interface PrimaryFill {
  /** Background style for the button, or undefined when no primary color is set. */
  style: CSSProperties | undefined;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

/**
 * The fill style for a button in the configured primary color.
 *
 * Inline backgrounds beat stylesheet `:hover` rules, so the hover swap is
 * driven from React state, with `opacity: 1` undoing any CSS hover dim.
 */
export function usePrimaryFill(
  primaryColor?: string,
  primaryHoverColor?: string,
  useGradient = false,
): PrimaryFill {
  const [hovered, setHovered] = useState(false);
  const onMouseEnter = () => setHovered(true);
  const onMouseLeave = () => setHovered(false);

  if (!primaryColor) {
    return { style: undefined, onMouseEnter, onMouseLeave };
  }

  const showHover = hovered && !!primaryHoverColor;
  const color = showHover ? primaryHoverColor! : primaryColor;
  const style: CSSProperties = {
    ...gradientBackground(color, useGradient),
    ...(showHover ? { opacity: 1 } : {}),
  };

  return { style, onMouseEnter, onMouseLeave };
}
